export enum AppFeatureSwitch {
  Payroll = 46
}

export enum AppPermission {
  ApproveDocumentUpload = 6100,
  BenefitsAccess = 6051,
  PayrollApprovalApprove = 154,
  PayrollApprovalViewAll = 3022,
  PayrollApprovalShowAllItems = 3069,
  PayrollApprovalViewAssigned = 3120,
  PayrollApprovalEditItems = 3126,
  PayrollApprovalViewMainCampus = 6030,
  HRPortalReimbursementsHRApproval = 12008,
  HRPortalReimbursementsAAInitialApproval = 12009,
  HRPortalReimbursementTypesView = 12010,
  HRPortalReimbursementTypesEdit = 12011
}

export enum BenefitEnrollmentApprovalStatus {
  Pending = 1,
  Approved = 2,
  Rejected = 3,
  Withdrawn = 4
}
